import(/* webpackMode: "eager" */ "/app/app/[lng]/reset-password/page.tsx");
